import { queriesOnboarding } from "@query";
import { useUserId } from "../../../../query/hooks/helpers";
import { useFeatureFlags } from "../../../../query/hooks/useFeatureFlags";
import { useQueryCustomerEntity } from "../../../../query/onboarding/queries/useQueryCustomerEntity";
import {
  useQueryMemberProfile,
  useQueryUserProfile
} from "../../../../query/users/queries";
import { WSQueries } from "../../../../query/WSQuery";
import { DataView } from "../../../../shared/components/DataView";
import { selectorAccountType } from "../../../../shared/selectors/selectorAccountType";
import { selectorAddressString } from "../../../../shared/selectors/selectorAddressString";
import { selectorMemberCountry } from "../../../../shared/selectors/selectorMemberCountry";
import { openIntercomMessage } from "../../../../shared/utils/intercom";
import { getTaxIdVerificationAlert } from "../../../../shared/utils/taxId";
import { useModalEditAddress } from "../../../Settings/routes/RouteAccount/components/FormEditAddress";

export const BusinessInformation: React.FC<{}> = () => {
  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);
  const queryMonitoredEntity = useQueryCustomerEntity();
  const modalEditAddress = useModalEditAddress();
  const queryUser = useQueryUserProfile(userId);
  const queryVerifications = queriesOnboarding.getOnboardingStatus.useQuery(
    undefined,
    { select: status => status.verifications }
  );
  const featureFlags = useFeatureFlags();

  const member = queryMember.data;

  return (
    <WSQueries
      queries={{
        queryMember,
        // queryMonitoredEntity,
        queryUser,
        featureFlags
        // queryVerifications
      }}
    >
      {({
        queryMemberData,
        featureFlagsData,
        // queryMonitoredEntityData,
        // queryVerificationsData,
        queryUserData
      }) => {
        const accountType = selectorAccountType(
          queryMonitoredEntity.data,
          queryMemberData
        );

        const verificationStatus = queryVerifications.data?.tax;
        const country = selectorMemberCountry(queryMemberData);

        const nameLabel =
          accountType === "Business" ? "Legal business name" : "Full name";
        const nameValue =
          accountType === "Business"
            ? member?.profile.company?.legalBusinessName
            : [
                queryUserData.profile.firstName,
                queryUserData.profile.lastName
              ].join(" ");

        const tinPostfix = accountType === "Business" ? " (EIN)" : " (SSN)";
        const tinValue =
          accountType === "Business" && member?.profile.company?.taxId
            ? member?.profile.company?.taxId
            : "•••••••••";

        return (
          <DataView
            loading={queryMember.isLoading || queryMonitoredEntity.isLoading}
            title="Business information"
            data={[
              {
                label: {
                  text: nameLabel,
                  actionPosition: "left",
                  action: {
                    label: "Contact support",
                    onClick: () => {
                      openIntercomMessage(
                        `Hi there! I want to update my ${nameLabel}.`
                      );
                    }
                  }
                },
                value: nameValue
              },
              {
                label: {
                  text: "Taxpayer identification number",
                  actionPosition: "left",
                  action: {
                    label: "Contact support",
                    onClick: () => {
                      openIntercomMessage(`Hi there! I want to update my TIN.`);
                    }
                  }
                },
                value: tinValue + tinPostfix,
                alert: getTaxIdVerificationAlert({
                  country,
                  status: verificationStatus,
                  isPendingPaused: featureFlagsData.is1099FilingPaused
                }),
                fsExclude: true
              },
              {
                label: {
                  text: "Business address",
                  actionPosition: "left",
                  action: {
                    label: "Edit",
                    onClick: () => {
                      modalEditAddress.open();
                    }
                  }
                },
                value: selectorAddressString(member?.profile.address, true),
                fsExclude: true
              }
            ]}
          />
        );
      }}
    </WSQueries>
  );
};
